import store from '../app/store';
import { save } from '../features/token/tokenSaver';
import { clearRoleSession } from './authSession';
import { clearUserSession } from './userSession';
import { resetAuthInterceptorState } from './axiosInterceptor';

/** Wipe stale credentials so login requests are never blocked by old tokens. */
export const prepareLoginPage = () => {
    clearRoleSession();
    clearUserSession();
    store.dispatch(save(''));
    resetAuthInterceptorState();
};
